import { data } from '../../svg/Archive/data';
import { makeIcon } from '../makeIcon';

export const Archive = makeIcon(data, 'archive', 'Archive');

export default Archive;
